<!--components\Paneles\PanelImagenMasAnchor.vue-->
<!--Anchor o img-->
<template>
  <a v-if="hasLink" :href="data.enlace" :class="data.clase_contenedor" class="block">
    <img
      :src="data.imagen"
      :alt="data.alt"
      :class="data.imagen_clase"
      :loading="data.prioridad ? 'eager' : 'lazy'"
      :fetchpriority="data.prioridad ? 'high' : 'auto'"
      decoding="async"
    />
  </a>
  <div v-else :class="data.clase_contenedor">
    <img
      :src="data.imagen"
      :alt="data.alt"
      :class="data.imagen_clase"
      :loading="data.prioridad ? 'eager' : 'lazy'"
      :fetchpriority="data.prioridad ? 'high' : 'auto'"
      decoding="async"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  data: { type: Object, required: true }
})

const hasLink = computed(() => !!props.data.enlace && props.data.enlace !== '#');
</script>